import { DRNDateUtil } from '@traveloka/district-util';
export const getFormattedDate = (date, format) => {
    const formatString = format || 'YYYY-MM-DD';
    return DRNDateUtil.dateToString(date, formatString);
};
export const getConvertedHolidayObj = holidayObj => {
    return Object.keys(holidayObj).reduce((accumulator, year) => {
        const monthObj = holidayObj[year];
        const convertedMonthObj = getMonthDate(year, monthObj);
        return Object.assign({}, accumulator, convertedMonthObj);
    }, {});
};
const getMonthDate = (year, monthObj) => {
    return Object.keys(monthObj).reduce((accumulator, month, index) => {
        const currentObj = monthObj[month];
        const datesArray = Object.keys(currentObj);
        datesArray.forEach(date => {
            const keyStr = year + '-' + normalizeNumber(month) + '-' + normalizeNumber(date);
            accumulator[keyStr] = currentObj[date];
        });
        return accumulator;
    }, {});
};
const normalizeNumber = numStr => {
    if (numStr.length > 1)
        return numStr;
    return '0' + numStr;
};
export const getSelectedDatesObj = (startDate, endDate, color) => {
    if (!endDate || DRNDateUtil.isEqual(startDate, endDate)) {
        const key = getFormattedDate(startDate);
        return { [key]: { color, selected: true } };
    }
    const dateArray = DRNDateUtil.eachDay(startDate, endDate);
    return dateArray.reduce((markedDatesObj, date, index) => {
        const key = getFormattedDate(date);
        markedDatesObj[key] = { color };
        if (index === 0) {
            markedDatesObj[key].startingDay = true;
        }
        else if (index === dateArray.length - 1) {
            markedDatesObj[key].endingDay = true;
        }
        return markedDatesObj;
    }, {});
};
